import React from 'react';

import { StoreSwitcherButton } from '../../components/StoreSwitcherButton/StoreSwitcherButton';
import { storeSwitcherHooks } from '../../hooks/storeSwitcherHooks/storeSwitcherHooks';

export type Props = {
  className?: string;
  iconFill?: string;
  isHeaderPart?: boolean;
  isNonBlockPart?: boolean;
  label: string;
  textClassName?: string;
};

export const StoreSwitcherButtonContainer = (
  {
    className,
    textClassName,
    iconFill,
    label,
    isNonBlockPart,
    isHeaderPart,
  }: Props,
) => {
  const handleOpenStoreSwitcherModal = storeSwitcherHooks.useOpenStoreSwitcherModal(
    isNonBlockPart,
  );
  return (
    <StoreSwitcherButton
      onClick={handleOpenStoreSwitcherModal}
      label={label}
      className={className}
      textClassName={textClassName}
      iconFill={iconFill}
      isHeaderPart={isHeaderPart}
    />
  );
};

StoreSwitcherButtonContainer.displayName = 'StoreSwitcherButtonContainer';
